export default "__VITE_ASSET__3YgiOUxa__"